import stateFactory from './state'
import gettersFactory from './getters'
import actionsFactory from './actions'
import mutationFactory from "./mutations"
import { BusinessLoginActions, BusinessLoginGetters, BusinessLoginMutations, BusinessLoginState } from "./types"
import { toRefs } from '@vue/composition-api'

let useBusinessLoginInitialized = false;
let sharedState: BusinessLoginState;
let getters: BusinessLoginGetters;
let mutations: BusinessLoginMutations;
let actions: BusinessLoginActions;

export default function useBusinessLogin() {

    if (false == useBusinessLoginInitialized) {
        sharedState = stateFactory();
        getters = gettersFactory(sharedState);
        mutations = mutationFactory(sharedState);
        actions = actionsFactory(sharedState, mutations);       

        useBusinessLoginInitialized = true;
    }

    return {
        ...toRefs(sharedState),
        ...getters!,
        ...actions!
    }
}